import React from 'react';

import { Button } from '@eika/button';
import { InfoCard } from '@eika/card';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';

import { EFakturaCreditor, EFakturaCreditorSkeleton } from '../../components/EFakturaCreditor';
import { Content } from '../../components/shared/Content';
import { ErrorCardWrapper } from '../../components/shared/ErrorCardWrapper';
import { useEfakturaCreditors } from '../../fetchHooks/useEfaktura';
import useTranslation from '../../hooks/useTranslation';
import EFakturaHistoryHeader from './EFakturaHistoryHeader';

import './EFakturaHistory.scss';

const EFakturaHistory: React.FC = () => {
    const translated = useTranslation();
    const { data, error, isLoading, refetch } = useEfakturaCreditors();

    if (isLoading) {
        return (
            <>
                <EFakturaHistoryHeader />
                <ul className="efaktura-history__list">
                    {Array.from(Array(8)).map((_, index) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <EFakturaCreditorSkeleton key={index} />
                    ))}
                </ul>
            </>
        );
    }

    if (error) {
        return (
            <Content>
                <ErrorCardWrapper
                    title={translated.errors.oops}
                    exception={error}
                    defaultError={translated.eFakturaHistory.error}
                >
                    <Button onClick={() => refetch()}>{translated.tryAgain}</Button>
                </ErrorCardWrapper>
            </Content>
        );
    }

    if (!data.length) {
        return (
            <>
                <EFakturaHistoryHeader />
                <Content>
                    <InfoCard skipBackground>
                        <RichIcon type={RichIconTypes.BAAT_M_SOL} />
                        <InfoCard.TitleH2>{translated.eFakturaHistory.noCreditors}</InfoCard.TitleH2>
                    </InfoCard>
                </Content>
            </>
        );
    }

    return (
        <>
            <EFakturaHistoryHeader />
            <ul className="efaktura-history__list">
                {data.map((creditor) => (
                    <EFakturaCreditor name={creditor.name} key={creditor.creditorId.value} />
                ))}
            </ul>
        </>
    );
};

export default EFakturaHistory;
